import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../app/modules/auth/auth.service';
import type { NavArea } from '../../app/core/utils/permission.util';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css'],
})
export class SideNavComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  @Input() isOpen = false;
  @Output() closeSideNav = new EventEmitter<void>();

  get userInitials(): string {
    const name = this.userName;
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase() || 'U';
  }

  get userName(): string {
    return this.auth.currentUserName() || this.auth.currentUserEmail() || 'User';
  }

  get userRole(): string {
    return this.auth.currentRoleLabel();
  }

  get companyName(): string {
    return this.auth.currentCompanyName();
  }

  canSee(area: NavArea): boolean {
    return this.auth.canAccessNav(area);
  }

  close() {
    this.closeSideNav.emit();
  }

  onNavLinkClick(event: Event) {
    const target = event.target as HTMLElement;
    if (target.closest('a.nav-link')) {
      this.close();
    }
  }

  logout() {
    this.auth.logout();
    this.close();
    this.router.navigate(['/login']);
  }
}
